import React from 'react';
import { Box, Grid, makeStyles, Theme, Breadcrumbs, Link } from '@material-ui/core';
import { useHistory } from 'react-router';
import StatusChip from '../../components/StatusChip';
import { StyledText } from '../../components/StyledText';
import { InvestorProfile, Role } from '../../types/types';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: theme.spacing(0)
  },
  investorRoot: {
    margin: theme.spacing(0),
    padding: '25px 0',
    paddingBottom: 0
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
    margin: '15px 0',
    alignItems: 'center'
  }
}));

interface EntViewProps {
  investorName: string
  isPublished: boolean
}

const EntView:React.FC<EntViewProps> = ({
  investorName,
  isPublished
}) => {
  const styles = useStyles();
  const history = useHistory();

  if (!isPublished) {
    history.push('/');
  }

  return (
    <Grid item>
      <Breadcrumbs separator='>'>
        <StyledText
          variant='breadcrumbs'
          color='secondary'
          style={{ cursor: 'pointer' }}
          onClick={() => history.goBack()}
        >
          Matched Investors
        </StyledText>
        <StyledText variant='breadcrumbs' color='inherit'>
          {investorName}
        </StyledText>
      </Breadcrumbs>
      <Box display='flex' alignItems='center'>
        <Box className={styles.title}>
          <StyledText variant='h1'>
            {investorName}
          </StyledText>
        </Box>
      </Box>
    </Grid>
  );
};

interface ConnectorViewProps {
  profile: InvestorProfile
}

const ConnectorView:React.FC<ConnectorViewProps> = ({
  profile
}) => {
  const styles = useStyles();
  const history = useHistory();
  const { isPublished, contactName: investorName } = profile;

  const previousPath = (history.location.state as any)?.from || '';
  const backRoute = previousPath.includes('network') ? 'Network' : 'Deals';
  return (
    <Grid item>
      <Breadcrumbs separator='>'>
        <StyledText
          variant='h6'
          color='secondary'
          style={{ cursor: 'pointer' }}
          onClick={() => {
            if (backRoute === 'Network') {
              history.goBack();
            } else {
              history.push('/connector/deals/new');
            }
          }}
        >
          {backRoute}
        </StyledText>
        <StyledText variant='h6' color='inherit'>
          {investorName || 'New Investor'}
        </StyledText>
      </Breadcrumbs>
      <Box display='flex' alignItems='center'>
        <Box className={styles.title}>
          <StyledText variant='h1'>
            {investorName || 'Investor Name'}
          </StyledText>
          <StatusChip
            style={{ marginLeft: 20 }}
            status={isPublished ? 'Published' : 'Incomplete'}
          />
        </Box>
      </Box>
    </Grid>
  );
};

interface InvestorTopbarProps {
  role: Role
  profile: InvestorProfile
  onPublish?: () => Promise<void> | undefined
}

const InvestorTopbar: React.FC<InvestorTopbarProps> = ({
  profile,
  role
}) => {
  const styles = useStyles();
  const { isPublished, contactName: investorName } = profile;
  return (
    <Grid id='investor-top-bar' container wrap='nowrap' direction='column' justify='center' className={styles.investorRoot}>
      {
        role === Role.Ent
          ? <EntView investorName={investorName} isPublished={isPublished} />
          : (
            <ConnectorView
              profile={profile}
            />
          )
      }
    </Grid>
  );
};

export default InvestorTopbar;
